module.exports = __webpack_public_path__ + "static/media/entrepot.f5771f7a.svg";